import { LocationThresholdSettingModal } from "./LocationThresholdSettingModal";

export default LocationThresholdSettingModal;
